import moment from 'moment';

export function formatarValorBRL(numeroDigitado: string) {
  // Remove todos os caracteres não numéricos, exceto a vírgula
  const valorLimpo = numeroDigitado.replace(/[^\d,]/g, '');

  // Divide a string em partes antes e depois da vírgula
  const partes = valorLimpo.split(',');

  // Formata a parte antes da vírgula com pontos como separadores de milhar
  let parteInteira = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  // Se houver uma parte decimal, concatena com a parte formatada antes da vírgula
  if (partes.length === 2) {
    return `R$ ${parteInteira},${partes[1].substring(0, 2)}`;
  } else {
    return `R$ ${parteInteira}`;
  }
}

export function converterBRLToFloat(value: string) {
  let entrada = value?.replace(/[^\d,]/g, '');

  // Substitui a vírgula por ponto para representar um float válido
  entrada = entrada?.replace(',', '.');

  // Tenta converter a string para um valor float
  const valorFloat: number = parseFloat(entrada);

  // Verifica se a conversão foi bem-sucedida
  if (!isNaN(valorFloat)) {
    return valorFloat;
  }
  return 0;
}

export function formatValueAsQuant(inputValue: string): string {
  // Remove todos os caracteres não numéricos
  const numericValue = inputValue.replace(/\D/g, '');

  // Formate o valor inserindo pontos como separadores de milhar
  return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function maskCapitalized(value: string): string {
  if (!value) return value;
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

export function maskDate(value: Date): string {
  return value ? moment(value).format('LL') : '';
}

export function maskDateStr(value: any): string {
  return value ? moment(value).format('DD/MM/YYYY') : '';
}

export function maskDateYear(value: any): string {
  return value ? moment(value).format('YYYY') : '';
}

export function maskDateTime(value: Date): string {
  return value ? moment(value).format('DD/MM/YYYY HH:mm') : '';
}

export function maskTime(value: number): string {
  var numberWithZeroes = String(value);
  var counter = numberWithZeroes.length;

  while (counter < 4) {
    numberWithZeroes = '0' + numberWithZeroes;
    counter++;
  }
  const hour = numberWithZeroes.slice(0, 2);
  const minutes = numberWithZeroes.slice(2, 4);
  return `${hour}:${minutes}`;
}

function allReplace(originalString: string, obj: any) {
  for (var x in obj) {
    originalString = originalString.replace(new RegExp(x, 'g'), obj[x]);
  }
  return originalString;
}

export function unmask(value: string) {
  if (!value) return value;
  return allReplace(value, { ' ': '', '-': '', _: '', '\\(': '', '\\)': '', '\\/': '', '\\.': '' });
}

export function phoneMask(rawValue: string) {
  const unmaskedValueLength = unmask(rawValue).length;
  if (unmaskedValueLength <= 10)
    return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  return ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
}

export function formatPhoneNumber(input: string): string {
  const cleanedInput = input.replace(/\D/g, '');

  const isValidLength = cleanedInput.length === 10 || cleanedInput.length === 11;
  if (!isValidLength) {
    return cleanedInput;
  }

  const ddd = cleanedInput.slice(0, 2);
  const firstPart = cleanedInput.slice(2, cleanedInput.length - 4);
  const secondPart = cleanedInput.slice(cleanedInput.length - 4);

  if (cleanedInput.length === 10) {
    return `(${ddd}) ${firstPart}-${secondPart}`;
  } else {
    return `(${ddd}) ${firstPart}-${secondPart}`;
  }
}

export function validatePhoneInput(event: any) {
  let { value } = event.target;

  value = value.replace(/\D/g, '');
  value = value.replace(/(\d{2})/, '($1) ');
  const isMobilePhone = /^[(][0-9][0-9][)][\s][9]/.test(value);

  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }

  if (isMobilePhone) {
    event.currentTarget.maxLength = 16;
    value = value.replace(/\D/g, '');
    value = value.replace(/(\d{2})(\d{1})/, '($1) $2.');
    value = value.replace(/(\d{4})/, '$1-');
    value = value.replace(/(\d{4})/, '$1');
  } else {
    event.currentTarget.maxLength = 14;
    value = value.replace(/(\d{4})/, '$1-');
    value = value.replace(/(\d{4})/, '$1');
  }

  event.currentTarget.value = value;
}

export function maskUnd(value: number): string {
  //eslint-disable-next-line
  if ((!value && value !== 0) || value === 0) return '' + value;
  return '' + value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function maskUndInt(value: number): string {
  //eslint-disable-next-line
  if ((!value && value !== 0) || value === 0) return '' + value;
  return '' + value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

export function maskPhone(value: string): string {
  return value;
}

export function maskCurrency(value: number): string {
  if (!value && value !== 0) return '' + value;
  return (
    'R$ ' + value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  );
}

export function formatarPeso(numeroDigitado: string) {
  const valorLimpo = numeroDigitado?.replace(/[^\d,]/g, '');

  const partes = valorLimpo?.split(',');

  let parteInteira = partes[0]?.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  if (partes.length === 2) {
    return parteInteira + ',' + partes[1].slice(0, 3);
  } else {
    return parteInteira;
  }
}

function formatCNPJCPF(cnpj_cpf: string): string {
  if (!cnpj_cpf) return '';

  const cleanedCNPJ_CPF = cnpj_cpf?.replace(/\D/g, '');

  if (cleanedCNPJ_CPF.length === 14) {
    return cleanedCNPJ_CPF?.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

  if (cleanedCNPJ_CPF.length === 11) {
    return cleanedCNPJ_CPF?.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
  }

  return cleanedCNPJ_CPF;
}

function maskCpfCnpj(value: string): string {
  if (!value) return value;

  if (value.length === 11) {
    return (
      value.slice(0, 3) +
      '.' +
      value.slice(3, 6) +
      '.' +
      value.slice(6, 9) +
      '-' +
      value.slice(9, 12)
    );
  } else if (value.length === 14) {
    return (
      value.slice(0, 2) +
      '.' +
      value.slice(2, 5) +
      '.' +
      value.slice(5, 8) +
      '/' +
      value.slice(8, 12) +
      '-' +
      value.slice(12, 15)
    );
  } else return value;
}

function maskDateFormated(value: Date): string {
  return value ? moment(value).format('LL') : '';
}

function maskCamelCase(value: string): string {
  if (value?.length <= 2) return value?.toUpperCase();
  if (!value || !value.split) return value;

  let values = value.split(' ');
  let result = '';

  values.forEach((v) => {
    let substring;
    if (
      v.toLowerCase() === 'a' ||
      v.toLowerCase() === 'e' ||
      v.toLowerCase() === 'o' ||
      v.toLowerCase() === 'ao' ||
      v.toLowerCase() === 'da' ||
      v.toLowerCase() === 'de' ||
      v.toLowerCase() === 'do'
    ) {
      substring = v.toLowerCase();
    } else {
      substring = v.substr(0, 1)?.toUpperCase() + v.substr(1).toLowerCase();
    }

    result += substring + ' ';
  });

  return result;
}

function maskCidadeUf(text: string) {
  const cidade = text.split('-')[0];
  const uf = text.split('-')[1];
  if (!cidade || !uf) return maskCamelCase(text);
  return `${maskCamelCase(cidade)} - ${uf}`;
}

function maskTransportadoraUf(text: string) {
  const cidade = text?.split('-')[0];
  const uf = text?.split('-')[1];
  if (!cidade || !uf) return maskCamelCase(text);
  return `${maskCamelCase(cidade)} - ${uf}`;
}

function maskPeso(value: number): string {
  //eslint-disable-next-line
  if ((!value && value !== 0) || value === 0) return '' + value;
  return (
    value.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) + ' Kg'
  );
}

function maskTonelada(value: number): string {
  if ((!value && value !== 0) || value === 0) return '' + value;

  if (value >= 1000) {
    const toneladas = value / 1000;
    return (
      toneladas.toLocaleString('pt-BR', { maximumFractionDigits: 1, minimumFractionDigits: 0 }) +
      ' Toneladas'
    );
  }

  return (
    value.toLocaleString('pt-BR', { maximumFractionDigits: 3, minimumFractionDigits: 0 }) + ' Kilos'
  );
}

type MaskTypes =
  | 'camelCase'
  | 'cidadeUf'
  | 'pesoTonelada'
  | 'cpfCnpj'
  | 'date'
  | 'dateTime'
  | 'currency'
  | 'phone'
  | 'peso'
  | 'transportadoraUf'
  | 'quantidade'
  | 'phone'
  | 'pesoInput'
  | 'cnpjCpfInput';
export function mask(maskType: MaskTypes, value: any): string {
  switch (maskType) {
    case 'camelCase':
      return maskCamelCase(value);

    case 'cidadeUf':
      return maskCidadeUf(value);

    case 'cpfCnpj':
      return maskCpfCnpj(value);

    case 'date':
      return maskDateFormated(value);

    case 'dateTime':
      return maskDateTime(value);

    case 'currency':
      return maskCurrency(value);

    case 'phone':
      return maskPhone(value);

    case 'peso':
      return maskPeso(value);

    case 'pesoTonelada':
      return maskTonelada(value);

    case 'transportadoraUf':
      return maskTransportadoraUf(value);

    case 'quantidade':
      return maskUndInt(value);

    case 'pesoInput':
      return formatarPeso(value);

    case 'cnpjCpfInput':
      return formatCNPJCPF(value);
  }
}

export default mask;
